<script setup lang="ts">
interface Props {
  class?: string
}
defineProps<Props>()
</script>

<template>
  <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" :class="$props.class">
    <slot />
  </div>
</template>
